import api from './api'

export default {
  async getAll() {
    const { data } = await api.get('/admin/companies')
    return data
  },

  async getById(id) {
    const { data } = await api.get(`/admin/companies/${id}`)
    return data
  },

  async create(companyData) {
    const { data } = await api.post('/admin/companies', companyData)
    return data
  },

  async update(id, companyData) {
    const { data } = await api.put(`/admin/companies/${id}`, companyData)
    return data
  },

  async delete(id) {
    const { data } = await api.delete(`/admin/companies/${id}`)
    return data
  }
}

